import BaseDialogTitle from "./BaseDialogTitle";
import {Box, Button, Dialog, DialogActions, DialogContent, Typography} from "@mui/material";


interface DialogAlertProps {
    open: boolean,
    onClose: () => void,
    onAccept?: () => void,
    title: string,
    submitId?: string,
    subtitle: string
}

const DialogAlert = ({title, subtitle, onAccept, onClose, submitId, open}: DialogAlertProps) => {
    
    const handleAccept = () => {
        onAccept && onAccept()
        onClose()
    }
    
    return (
        <Dialog open={open}
                onClose={onClose}
                maxWidth={'sm'}
                fullWidth
        >
            <BaseDialogTitle title={title} onClose={onClose}/>
            <DialogContent>
                <Box mb={1}>
                    <Typography fontSize={15} sx={{ whiteSpace: 'pre-line' }}>
                        {subtitle}
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    Cancelar
                </Button>
                {
                    submitId ?
                        <Button type={'submit'} color={'primary'} form={submitId}>
                            Confirmar
                        </Button>
                        :
                    <Button onClick={handleAccept} color={'primary'}>
                        Confirmar
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}


export default DialogAlert